import { all, call, fork, put, take, takeEvery } from "redux-saga/effects";
import io from "socket.io-client";
import { getCookie } from "../../helpers/other/cookies";
import { Tokens } from "../../types/webchatConversation";
import { socketInitialized } from "./actions";
import { DISCONNECT_SOCKET, START_SOCKET } from "./constants";
import { disconnect } from "./sagas/disconnect";
import { read } from "./sagas/read";
import { readNewMessage } from "./sagas/readNewMessage";
import { startConv } from "./sagas/startConv";
import { write } from "./sagas/write";

function connect() {
  // ✅ Uzimamo token prvo iz cookie-ja, zatim fallback na localStorage
  const jwt =
    getCookie(Tokens.GUEST_TOKEN) ||
    localStorage.getItem(Tokens.GUEST_TOKEN) ||
    getCookie(Tokens.AUTH_TOKEN) ||
    localStorage.getItem(Tokens.AUTH_TOKEN);
  const lang = localStorage.getItem("i18nextLng") || "en";

  const socket = io(process.env.REACT_APP_HOST_SOCKET as string, {
    transports: ["websocket"],
    query: {
      jwt,
      lang,
    },
  });

  return new Promise((resolve) => {
    socket.on("connect", () => {
      resolve(socket);
    });
  });
}

function* flow() {
  const socket = yield call(connect);
  yield fork(startConv, socket);
  yield fork(read, socket);
  yield fork(write, socket);
  yield fork(readNewMessage, socket);
  yield fork(disconnect, socket);
  yield put(socketInitialized());
  yield fork(disconnect, socket);

  // Slušamo DISCONNECT_SOCKET akciju
  yield take(DISCONNECT_SOCKET);
  socket.disconnect(); // Zatvaramo socket
}

function* watchStartSocket() {
  yield takeEvery(START_SOCKET, flow);
}

function* chat() {
  yield all([fork(watchStartSocket)]);
}

export default chat;
